<template>
    <ion-page>
      <ion-header>
        <ion-toolbar>
          <ion-buttons slot="start">
            <ion-back-button @click="$utils.goBack($router)"   text="Quay lại" defaultHref="/tabs/main"></ion-back-button>
          </ion-buttons>
          <ion-title>Cập nhật email</ion-title>
          <ion-label slot="end" style="margin-right: 2vw"></ion-label>
        </ion-toolbar>
      </ion-header>
      <ion-content class="ion-padding">

        <p style="margin-bottom: 4vh; font-style: italic">
          Email dùng để GimoLott gửi thông tin xác nhận đơn hàng và hình ảnh vé các loại sản phẩm Mega, Power, Max3D, Max4D đến quý khách hàng.
          Chúng tôi cam kết tuyệt đối không chia sẻ, mua bán thông tin email đến bất kỳ bên thứ ba nào.
        </p>

        <ion-list-header lines="full" style="align-items:center">
          <ion-label style="margin-top: 6px">Email hiện tại</ion-label>
          <ion-badge color="medium" v-if="!$store.state.auth.emailVerified">Chưa xác thực</ion-badge>
          <ion-badge color="primary" v-else>Đã xác thực</ion-badge>
        </ion-list-header>

        <ion-list v-if="$store.state.auth.email" lines="none">
          <ion-item>
            {{ $store.state.auth.email }}
          </ion-item>

          <ion-item v-if="!$store.state.auth.emailVerified">
            <ion-input placeholder="Nhập mã xác thực" v-model="inputCode"></ion-input>
            <ion-button @click="checkCode">Kiểm tra</ion-button>
          </ion-item>
        </ion-list>
        <ion-list v-else lines="none">
          <ion-item>
            <p style="text-align: center">Chưa nhập địa chỉ email</p>
          </ion-item>
        </ion-list>

        <ion-list-header lines="full">
          <ion-label>Đổi email/gửi mã xác thực</ion-label>
        </ion-list-header>
        <ion-list>
          <ion-item>
            <ion-input placeholder="Nhập email mới.." v-model="inputEmail"></ion-input>
            <ion-icon :icon="pencilSharp" color="medium"></ion-icon>
          </ion-item>
        </ion-list>

        <p style="text-align: center; font-style: italic">Sau khi gửi yêu cầu, chúng tôi sẽ gửi một thư xác nhận đến hộp mail có chứa mã xác nhận email, vui lòng nhập xác thực vào ô kiểm tra.</p>

        <ion-button expand="block" @click="verify">GỬI YÊU CẦU</ion-button>
      </ion-content>
    </ion-page>
</template>

<style scoped>

</style>

<script>
import { defineComponent } from 'vue'
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonContent,
  IonButtons,
  IonBackButton,
  IonTitle,
  IonLabel,
  IonList,
  IonListHeader,
  IonItem,
  IonButton,
  IonInput,
  IonBadge,
  IonIcon,
} from '@ionic/vue';

import {
  pencilSharp
} from 'ionicons/icons'

export default defineComponent({
  name: 'EditEmail',
  components: {
    IonPage,
    IonHeader,
    IonToolbar,
    IonContent,
    IonButtons,
    IonBackButton,
    IonTitle,
    IonLabel,
    IonList,
    IonListHeader,
    IonItem,
    IonButton,
    IonInput,
    IonBadge,
    IonIcon,
  },
  data() {
    return {
      inputEmail: '',
      inputCode: '',
    }
  },
  mounted() {
    this.inputEmail = String(this.$store.state.auth.email);
  },
  methods: {
    async checkCode() {
      if (!this.inputCode) {
        (await this.$utils.toast("Xin hãy nhập mã xác nhận", {position: "top"})).present();
        return;
      }

      await this.$utils.showLoading();

      try {
        const resp = await this.$utils.callAPI('POST', '/customers/email', {
          code: this.inputCode,
        });
        if (resp.status >= 200 && resp.status <= 299) {
          if (resp.data && resp.data.message) {
            (await this.$utils.toast(resp.data.message, {position: "top", color: 'success'})).present();
          }
          this.$store.commit('auth_update_info', {
            emailVerified: resp.data.email_verified,
          });
        } else {
          if (resp.data && resp.data.message) {
            (await this.$utils.toast(resp.data.message, {position: "top"})).present();
          } else {
            (await this.$utils.toast("Có lỗi xảy ra từ máy chủ, quý khách vui lòng thử lại sau.", {position: "top"})).present();
          }
        }
      } catch (error) {
        (await this.$utils.toast("Vui lòng kiểm tra kết nối mạng và thử lại sau.", {position: "top"})).present();
      }

      await this.$utils.hideLoading();
    },
    async verify() {
      if (!this.inputEmail) {
        (await this.$utils.toast("Xin hãy nhập địa chỉ Email", {position: "top"})).present();
        return;
      }

      await this.$utils.showLoading();

      try {
        const resp = await this.$utils.callAPI('POST', '/customers/email', {
          email: this.inputEmail,
        });
        if (resp.status >= 200 && resp.status <= 299) {
          if (resp.data && resp.data.message) {
            (await this.$utils.toast(resp.data.message, {position: "top", color: 'success'})).present();
          }
          this.$store.commit('auth_update_info', {
            email: this.inputEmail,
            emailVerified: null,
          });
        } else {
          if (resp.data && resp.data.message) {
            (await this.$utils.toast(resp.data.message, {position: "top"})).present();
          } else {
            (await this.$utils.toast("Có lỗi xảy ra từ máy chủ, quý khách vui lòng thử lại sau.", {position: "top"})).present();
          }
        }
      } catch (error) {
        (await this.$utils.toast("Vui lòng kiểm tra kết nối mạng và thử lại sau.", {position: "top"})).present();
      }

      await this.$utils.hideLoading();
    }
  },
  setup() {
    return {
      pencilSharp
    }
  },
})
</script>
